export default function PHP_xml_error_string() {
  return (
    <div>
      <h1>PHP_xml_error_string</h1>
    </div>
  );
}
